import React, { useId } from 'react';
import { Field, FieldError, FieldLabel } from '../../shadcn/components/ui/field';
import { Input } from '../../shadcn/components/ui/input';
import { cn } from '../../shadcn/lib/utils';

// Labelled auth input. `hideLabel` keeps the label for screen readers only.
// `helperText` is the error message, shown under the input.
export default function AuthTextField({ label, hideLabel = false, id, error, helperText,
  placeholder = label, inputProps = {}, ...props }) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const errorId = error && helperText ? `${inputId}-error` : undefined;
  const describedBy = [inputProps['aria-describedby'], errorId].filter(Boolean).join(' ') || undefined;
  return <Field data-invalid={error ? true : undefined} className="gap-1.5">
    <FieldLabel htmlFor={inputId} className={cn(hideLabel && 'sr-only')}>{label}</FieldLabel>
    <Input {...props} {...inputProps} id={inputId} placeholder={placeholder}
      aria-invalid={error ? true : undefined} aria-describedby={describedBy} />
    {errorId && <FieldError id={errorId}>{helperText}</FieldError>}
  </Field>;
}
